// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2g-1";
export var rateTableServiceLevelDropdown = "_2g-3";
export var rateTableTypeDropdown = "_2g-0";
export var rateTableValueModeDropdown = "_2g-2";